import React from 'react';
import { siteConfig } from '../data/config';
import { Link } from 'react-router-dom';
import { FaInstagram, FaYoutube, FaTiktok, FaAt } from 'react-icons/fa';

const socialIcons = {
    instagram: FaInstagram,
    youtube: FaYoutube,
    tiktok: FaTiktok,
    thread: FaAt
};

const Footer = () => {
    return (
        <footer className="footer">
            <div className="container">
                <div className="social-links">
                    {Object.entries(siteConfig.socialLinks).map(([platform, url]) => {
                         const Icon = socialIcons[platform];
                         return (
                             <a 
                                 key={platform} 
                                 href={url}
                                 target="_blank"
                                 rel="noopener noreferrer"
                                 className="social-link"
                             >
                                 <Icon />
                             </a>
                         );
                     })}
                </div>
                <div className="footer-links">
                    <Link to="/mentions-legales">Mentions légales</Link>
                    <Link to="/espace-pro">Espace pro</Link>
                </div>
                <p>Contact: {siteConfig.contactEmail}</p>
                <p>© {new Date().getFullYear()} {siteConfig.humoristName}</p>
            </div>
        </footer>
    );
};

export default Footer;